import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import Delete from '@mui/icons-material/Delete'

export const FormCustomerTypeRuleEdit = memo((props) => {
  const { setRules, setRulesKeys, rulesKeys, rules, rule } = props.ruleHandlers
  const { setSelectedRuleKeys, selectedRuleKeys, ruleKey } = props
  const { deleteMode } = useSelector(state => state.contractsCatalog)
  const [ruleKeysOptionsFiltered, setRuleKeysOptionsFiltered] = useState(rule.ruleKeys)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({ id: '' })
  const { id } = inputValues
  const validRuleKeys = useMemo(() => rule.ruleKeys.map(ruleKey => ruleKey.id), [rule]) 

  useEffect(() => {
    if(rule.ruleKeys.filter(option => option.id === ruleKey.idRuleKey).length)
      handleNewValues({ id: ruleKey.idRuleKey })
    //eslint-disable-next-line 
  }, [ruleKey.idRuleKey, rulesKeys])

  useEffect(() => {
    if(!selectedRuleKeys.filter(selectedRuleKey => !validRuleKeys.includes(selectedRuleKey.idRuleKey)).length)
      setRules(rules.map(rule => {
        if (rule.id === ruleKey.idRule) return {...rule, isComplete: 'good'}
        return rule
      }))
    else if(rule.isComplete === 'good') setRules(rules.map(rule => {
      if (rule.id === ruleKey.idRule) return {...rule, isComplete: 'bad'}
      return rule
    }))
    //eslint-disable-next-line 
  }, [selectedRuleKeys])

  useEffect(() => {
    if(id && id !== ruleKey.idRuleKey) {
      setRulesKeys([...rulesKeys.filter(item => item.idRuleKey !== ruleKey.idRuleKey),{idRule: rule.id, idRuleKey: id}])
      setSelectedRuleKeys(selectedRuleKeys.map(item => {
        if(item.itemId === ruleKey.itemId) return {idRule: rule.id, idRuleKey: id, itemId: ruleKey.itemId} 
        return item
      }))
    }
    //eslint-disable-next-line 
  }, [handleInputOnChange])

  useEffect(() => {
    if(selectedRuleKeys.length) {
      const rulesKeysSelected = selectedRuleKeys.filter(item => item.itemId !== ruleKey.itemId).map(rule => rule.idRuleKey)
      setRuleKeysOptionsFiltered(rule.ruleKeys.filter(option => !rulesKeysSelected.includes(option.id)))
    }
    //eslint-disable-next-line 
  }, [selectedRuleKeys])

  return (
    <>
      <FormControl style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        gap: 10, 
        marginTop: 20, 
        alignItems: 'center', 
        flexDirection: 'row', 
        width: '90%'
      }}>
        <FormControl style={{flexGrow: 1}} variant="outlined">
          <InputLabel>Tipo de Cliente *</InputLabel>
          <Select
            name="id"
            value={id}
            onChange={e => handleInputOnChange(e)}
            label="Tipo de Cliente *"
            disabled={deleteMode}
          > 
            { ruleKeysOptionsFiltered.map(item => <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>) }
          </Select>
        </FormControl>
        <RegularButton 
          round 
          justIcon 
          color={"danger"} 
          style={{ margin: 0 }}
          disabled={selectedRuleKeys.length === 1} 
          onClick={(e) => {
            e.stopPropagation()
            setRulesKeys(rulesKeys.filter(item => item.idRuleKey !== ruleKey.idRuleKey))
            setSelectedRuleKeys(selectedRuleKeys.filter(item => item.idRuleKey !== ruleKey.idRuleKey))
          }}
        >
          <Delete style={{ margin: 0 }}/>
        </RegularButton>
      </FormControl>
    </>
  )
})
